const SITE_ORIGIN = process.env.VUE_APP_SITE_ORIGIN || 'http://47.237.200.139'
const API_ORIGIN = process.env.VUE_APP_API_ORIGIN || `${SITE_ORIGIN}:8000`

export default {
    teacher: [
        {
            name: 'SutdentManage',
            title: '学生管理',
            icon: 'el-icon-s-custom',
            component: '',
            path: '',
            children: [
                {
                    name: 'StudentList',
                    title: '学生列表',
                    icon: 'el-icon-user',
                    path: '/teacher/studentlist',
                    component: 'teacher/StudentList',
                    children: []
                }
            ]
        },
        {
            name: 'ClassManage',
            title: '公司管理',
            icon: 'el-icon-s-grid',
            path: '',
            component: '',
            children: [
                {
                    name: 'ClassList',
                    title: '公司列表',
                    icon: 'el-icon-medal-1',
                    path: '/teacher/Classlist',
                    component: 'teacher/ClassList',
                    children: []
                },
            ]
        },
        {
            name: 'SubjectManage',
            title: '学科管理',
            icon: 'el-icon-collection',
            path: '',
            component: '',
            children: [
                {
                    name: 'SubjectList',
                    title: '学科列表',
                    icon: 'el-icon-notebook-1',
                    path: '/teacher/SubjectList',
                    component: 'teacher/SubjectList',
                    children: []
                },
            ]
        },
        {
            name: 'TitleManage',
            title: '试题管理',
            icon: 'el-icon-folder-opened',
            path: '',
            component: '',
            children: [
                {
                    name: 'TitleList',
                    title: '试题列表',
                    icon: 'el-icon-tickets',
                    path: '/teacher/TitleList',
                    component: 'teacher/TitleList',
                    children: []
                },
                {
                    name: 'ShortAnswer',
                    title: '简答题创编',
                    icon: 'el-icon-document',
                    path: '/teacher/ShortAnswer',
                    component: 'teacher/ShortAnswer',
                    children: []
                },
                {
                    name: 'JudgeTitle',
                    title: '判断题创编',
                    icon: 'el-icon-document-add',
                    path: '/teacher/JudgeTitle',
                    component: 'teacher/JudgeTitle',
                    children: []
                },
                {
                    name: 'SingleChoice',
                    title: '单选题创编',
                    icon: 'el-icon-notebook-1',
                    path: '/teacher/SingleChoice',
                    component: 'teacher/SingleChoice',
                    children: []
                },
                {
                    name: 'MultiChoice',
                    title: '多选题创编',
                    icon: 'el-icon-collection-tag\n',
                    path: '/teacher/MultiChoice',
                    component: 'teacher/MultiChoice',
                    children: []
                },
            ]
        },
        {
            name: 'PaperManage',
            title: '卷库管理',
            icon: 'el-icon-s-cooperation',
            path: '',
            component: '',
            children: [
                {
                    name: 'PaperList',
                    title: '试卷列表',
                    icon: 'el-icon-s-promotion',
                    path: '/teacher/PaperList',
                    component: 'teacher/PaperList',
                    children: []
                },
                {
                    name: 'EditPaper',
                    title: '试卷创编',
                    icon: 'el-icon-s-flag',
                    path: '/teacher/EditPaper',
                    component: 'teacher/EditPaper',
                    children: []
                },
            ]
        },
        {
            name: 'TaskManage',
            title: '考试任务',
            icon: 'el-icon-s-management',
            path: '',
            component: '',
            children: [
                {
                    name: 'EditTask',
                    title: '发布考试',
                    icon: 'el-icon-folder-add',
                    path: '/teacher/EditTask',
                    component: 'teacher/EditTask',
                    children: []
                },
                {
                    name: 'MarkPaper',
                    title: '答卷批改',
                    icon: 'el-icon-document-checked',
                    path: '/teacher/MarkPaper',
                    component: 'teacher/MarkPaper',
                    children: []
                },
            ]
        },

    ],
    studentPermission: ['student', 'StudentIndex', 'Login', 'StudentExam', 'StudentCheckPaper',],
    SITE_ORIGIN,
    API_ORIGIN,
    BASE_URL: `${API_ORIGIN}/api/v1`,
    BANNER_URL: API_ORIGIN,
}
